import MetadataBase from "./MetadataBase";

export default class AttributeGroup extends MetadataBase{
    /**
   *
   * @param {Element} node
   * @param {import("./XMLRDBNavigation").default} xmlRDBNavigation
   */
  constructor(node, xmlRDBNavigation, parentMetadata) {
    super(node, xmlRDBNavigation, parentMetadata);
    /** @type {Array<import("./Attribute").default>}}*/
    this.attributes = [];
  }

  name() {
    return this.getNodeAttribute("name");
  }

  visibleAttributes(dataElement) {
    return this.attributes.filter(a => a.isVisible(dataElement));
  }

  visibleFormAttributes(dataElement) {
    return this.attributes.filter(a => a.isFormVisible(dataElement));
  }

  isVisible(dataElement) {
    return super.isVisible(dataElement) && this.visibleAttributes(dataElement).length > 0;
  }

  isFormVisible(dataElement) {
    return super.isVisible(dataElement) && this.visibleFormAttributes(dataElement).length > 0;
  }

}